import { cn } from '@/lib/utils';
import type { QuizPlayerScreenType } from '../types';

export const QuizPlayerScreen = ({
  className,
  variant,
  ...others
}: React.ComponentProps<'div'> & { variant: QuizPlayerScreenType }) => {
  return (
    <div
      {...others}
      className={cn(className)}
      data-variant={variant}
      data-slot="quiz-player-screen"
    />
  );
};
